import React, { memo } from 'react';

import NextImage from 'next/image';
import ContentLoader from 'react-content-loader';

import { CATCH_MAP_HEIGHT, CATCH_MAP_WIDTH } from '../../../constants/constants';
import { GetPost_entry_catch_fishingWater } from '../../../interfaces/graphql';
import { getStaticCatchMap } from '../../Maps/mapData/staticMaps';
import style from '../CatchMap.module.css';

import { SecretWaterMap } from './SecretWaterMap';

interface ICatchLayerProps {
  isCatchMapVisible: boolean;
  waterMapIsVisible: boolean;
  latitude?: number;
  longitude?: number;
  waterDetails?: GetPost_entry_catch_fishingWater;
}

export const MapLayer = ({
  isCatchMapVisible,
  waterMapIsVisible,
  latitude,
  longitude,
  waterDetails,
}: ICatchLayerProps) => {
  if (isCatchMapVisible && latitude !== undefined && longitude !== undefined) {
    const source = getStaticCatchMap(
      longitude.toString(),
      latitude.toString(),
      CATCH_MAP_WIDTH,
      CATCH_MAP_HEIGHT,
      'satellite',
    );
    return (
      <div className="relative h-64 w-full">
        {source ? (
          <NextImage
            alt="Catch map"
            data-testid="Map"
            className="absolute top-0 left-0 size-full object-cover"
            src={source}
            width={CATCH_MAP_WIDTH}
            height={CATCH_MAP_HEIGHT}
            unoptimized
          />
        ) : (
          <ContentLoader className="size-full overflow-hidden" uniqueKey="catchcard">
            <rect x="0" y="0" rx="5" ry="5" width="500" height="500" />
          </ContentLoader>
        )}
      </div>
    );
  }

  if (waterMapIsVisible) {
    return (
      <div className="h-64 w-full bg-cover bg-center bg-no-repeat">
        <SecretWaterMap waterDetails={waterDetails} />
      </div>
    );
  }

  return <div className={`${style.mapStill} h-64`} data-testid="BlurredMap" />;
};

export const CatchMapLayer = memo(MapLayer);
